import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { gettext } from "web/script/modules/django-i18n";
import { SizePropType } from "web/types/buy-option";
import styles from "./size-picker.css";


function Size({ size }) {
    const inStock = size.stock_status === 3;
    const label = size.label;
    return (
        <li className={styles.size}>
            {/* This span + classes fixes bug that strike though size sometimes appears thinner */}
            <span
                className={classnames(styles.sizeText, {
                    [styles.oos]: !inStock,
                })}
                // "Unavailable"
                aria-label={
                    inStock
                        ? label
                        : `${label} ${gettext("in_stock_product.sizes.unavailable_aria_label")}`
                }
            >
                {label}
            </span>
        </li>
    );
}

Size.propTypes = {
    size: SizePropType.isRequired,
};

function SizePicker({ allSizesSorted, buyOptionSizes }) {
    let [open, setOpen] = useState(false);
    let sizeArray = allSizesSorted
        .map((sizeKey) => buyOptionSizes[sizeKey])
        // Only include sizes on this buy option (ones missing will be undefined, so filtered out)
        .filter((size) => size);

    return (
        <div className={styles.wrapper}>
            <ul className={styles.sizes}>
                {sizeArray &&
                    sizeArray.slice(0, 10).map((size) => {
                        return <Size key={size.size_key} size={size} />;
                    })}
                {open &&
                    sizeArray.slice(10).map((size) => {
                        return <Size key={size.size_key} size={size} />;
                    })}
            </ul>
            {sizeArray.length > 10 && (
                <button className={styles.more} onClick={() => setOpen(!open)}>
                    <span>{open ? gettext("general.see_less") : gettext("general.see_more")}</span>
                </button>
            )}
        </div>
    );
}

SizePicker.propTypes = {
    buyOptionSizes: PropTypes.objectOf(SizePropType).isRequired,
    allSizesSorted: PropTypes.array,
};

export default SizePicker;
